import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "user",
  "use": "user-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 18\" id=\"user\"><path d=\"M13.72 11.59c-.02.02-.04.05-.06.07-.35.35-.74.66-1.14.94 1.18.71 1.98 2 1.98 3.48V18H16v-1.92c0-1.85-.9-3.48-2.28-4.49zM8 0C4.69 0 2 2.69 2 6c0 1.89.87 3.57 2.24 4.67-2.43.6-4.24 2.79-4.24 5.41V18h1.5v-1.92C1.5 13.83 3.33 12 5.58 12H8c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10.5c-2.48 0-4.5-2.02-4.5-4.5S5.52 1.5 8 1.5s4.5 2.02 4.5 4.5-2.02 4.5-4.5 4.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol